import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';

export const Wrapper = styled.div`
	position: absolute;
	cursor: pointer;
`;

export const Text = styled.div`
	color: ${colors.grey8};
`;
